import {connect} from "react-redux"
import State from "../../models/State"
import {setPageItemsThunk} from "../../ducks/search"

export const mapStateToProps = ({search, text}: State) => {
    const {startPage} = search
    return {
        startPage,
        text,
    }
}

export const mapDispatchToProps = {
    loadFirstPage: (historyUrl: string) =>
        setPageItemsThunk({
            historyUrl,
            enableDebounce: false,
        }),
}

export default connect(mapStateToProps, mapDispatchToProps)
